export default "/images/vendor/@coreui/icons/svg/flag/cif-cu.svg?da74e21209c0ce5f06eb3b4d2c12025b";